import { getComparePageBySlug } from "@/app/seo-compare";
import { CompareLayout } from "./CompareLayout";

export default function HotlineVsSkills() {
  const page = getComparePageBySlug("hotline-vs-skills");
  if (!page) return null;
  return <CompareLayout page={page} />;
}
